import React from 'react';
import { Chip, MenuItem, Box, Checkbox, FormControl, Select,  FormHelperText } from '@mui/material';
import { useField, useFormikContext } from 'formik';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const MultipleSelectWrapper = ({
  name,
  label,
  options,
  ...otherProps
}) => {
  const { values, setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);


  const handleChange = evt => {
    const { value } = evt.target;
    setFieldValue(name, value);
  };

  const configSelect = {
    ...field,
    ...otherProps,
    variant: 'outlined',
    fullWidth: true,
    size: "small",
    multiple: true,
    onChange: handleChange,
    MenuProps: MenuProps,
    value: values.skillIds
  };

  let errorText = ""

  if (meta && meta.touched && meta.error) {
    configSelect.error = true;
    errorText = meta.error;
  }

  // value.indexOf(option.id) > -1

  return (
    <Box sx={{ pt: 3 }}>
      <p>{label}</p>
      <FormControl fullWidth size="small" sx={{ pb: 2 }}>
        <Select
          {...configSelect}
          renderValue={(selected) => {
            return (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip
                    key={value}
                    label={options.find((el) => el.id === value)?.label}
                  />
                ))}
              </Box>
            );
          }}
        >
          {options.map((option) => {
            return (
              <MenuItem key={option.label} value={option.id}>
                <Checkbox checked={values.skillIds.indexOf(option.id) > -1} />
                {option.label}
              </MenuItem>
            );
          })}
        </Select>
        <FormHelperText error={meta && meta.touched && meta.error}>
          {errorText}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

export default MultipleSelectWrapper;
